module.exports = __webpack_public_path__ + "static/media/melbourne.35e175cc.jpg";